module.exports = __webpack_public_path__ + "static/media/card-unimed-30anos.bc9c8b28.png";